 * 文件EN: index.vue,
 * 文件CN: 商户激活
 */

<template>
  <div ref="indexPage" class="repatment-check">
    <!--搜索栏-->
    <!-- 上栏查询 -->
    <query-bar
      :query="query"
      :serviceList="selects.cityServiceList"
      :companyList="selects.companyList"
      :bankList="selects.channelList"
      :areaList="selects.activeCityList"
      :activeTypeList="selects.activeTypeList"
      @query="onClickQuery"
    />
    <!--  :activeTypeList="selects.activeCityList" 激活状态 -->
    <!-- {{ selects.areaList }} -->
    <!--  :areaList="selects.channelList"
      :companyList="targetTypeList"
      :bankList="queryTypeList" -->
    <!-- 数据列表 -->
    <list-data
      :loading="showLoading"
      :list-data="listData"
      @checkboxData="getCheckboxData"
    />

    <common-page :page-data="pageData" @change="onChangePage">
      <template #right-aside>
        <!-- disabled -->
        <button
          class="button"
          slot="right-aside"
          disabled
          @click="batchActivation"
        >
          批量激活
        </button>

        <!-- :disabled="showLoading" <button class="button" slot="right-aside" @click="getBlend">
          一键勾兑
        </button> -->
      </template>
    </common-page>
  </div>
</template>

<script>
import { dataListHeight, queryPage } from '@/mixins'
import { mapGetters } from 'vuex'
import tools from '@/utils/tools'

import QueryBar from './components/QueryBar'
import ListData from './components/ListData'

export default {
  mixins: [dataListHeight, queryPage],
  components: {
    QueryBar,
    ListData
  },

  data() {
    return {
      // 调用次数
      invokeCount: 0,
      // 合计成本：
      invokeCost: 0,

      // 下拉 触发对象
      targetTypeList: [
        { value: '', label: '全部' },
        { value: 1, label: '商户' },
        { value: 2, label: '供应商' }
      ],
      // 下拉 触发类型
      queryTypeList: [
        { value: '', label: '全部' },
        { value: 1, label: '黄名单' },
        { value: 2, label: '黑名单' }
      ],
      merIds: []
    }
  },
  filters: {
    // 时间转换
    toDateTime(time) {
      if (!time) return time
      let str,
        date = new Date(time)
      str =
        date.getFullYear() +
        '.' +
        toDouble(date.getMonth() + 1) +
        '.' +
        toDouble(date.getDate()) +
        ' ' +
        toDouble(date.getHours()) +
        ':' +
        toDouble(date.getMinutes()) +
        ':' +
        toDouble(date.getSeconds())
      return str
    },

    // 触发对象类型
    filterTargetType(num) {
      return {
        '': '-',
        '1': '商户',
        '2': '供应商'
      }[num]
    },

    // 触发类型
    filterQueryType(num) {
      return {
        '': '-',
        '1': '黄名单',
        '2': '黑名单'
      }[num]
    },

    // 释放方式
    filterReleaseTime(num) {
      return {
        '': '无释放方式',
        1: '1小时',
        2: '2小时',
        3: '6小时',
        4: '12小时',
        5: '24小时',
        6: '无限',
        7: '每日24点'
      }[num]
    }
  },
  computed: {
    ...mapGetters(['selects'])
  },

  async created() {
    // 收单机构下拉
    this.$store.dispatch('selects/getCompanyList')
    // 城市服务商下拉
    this.$store.dispatch('selects/getServiceList')
    // 渠道下拉
    this.$store.dispatch('selects/getChannelList')
    // 城市
    this.$store.dispatch('selects/getAllCityList')

    this.$store.dispatch('selects/getSelectActiveCity')
  },

  methods: {
    // 请求列表接口
    getListData() {
      const {
        query,
        $store: { dispatch },
        pageData: { currentPage, pageSize }
      } = this

      return dispatch('T7/merActivate/getList', {
        ...query,
        currentPage,
        pageSize
      }).then(res => {
        // if (res.status === 200) {
        // let type = [
        //   {
        //     createTime: '2020.01.11',
        //     merId: '0755-2456',
        //     merName: 'huli',
        //     corpName: 'corpName',
        //     corpPhone: 'corpPhone',
        //     area: 'area',
        //     orgName: 'orgName',
        //     serviceName: 'serviceName',
        //     bankName: 'bankName',
        //     quota: 'quota'
        //   }
        // ]
        // this.listData = type

        if (res.status == 200) {
          let { list, total, pages } = res.data

          this.listData = list
          this.pageData.total = total
          this.pageData.currentPage = pages
        }
        console.log('商户激活', res)

        // }

        // console.log(res, '商户激活')
      })
    },

    // 批量激活
    batchActivation() {
      if (this.merIds.length <= 0) {
        this.$alert.error('至少选中一个商户')
        return
      }

      // 调用批量激活的接口
      let { dispatch } = this.$store
      let dispatchEvent = 'T7/merActivate/batchUpdate'
      dispatch(dispatchEvent, { merId: this.merIds.toString() }).then(res => {
        if (res.status === 200) {
          this.$alert('激活成功')
          this.getListData()
        } else {
          this.$alert.error(res.msg)
        }
      })
    },

    // 选中的数据
    getCheckboxData(val) {
      this.merIds = []
      val.map(item => {
        this.merIds.push(item.merId)
      })
    },

    // 城市下拉
    getSelectActiveCity() {
      const { dispatch } = this.$store
      const dispatchEvent = 'public/getSelectActiveCity'
      dispatch(dispatchEvent).then(res => {
        console.log(res, '城市')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/css/Common/tableList.scss';
</style>
